export default {
    errno: 0,
    errmsg: 'ok',
    serverTime: 1670426654,
    data: {
        author: '四方环视鱼眼龙',
        enuid: '08de31313133323337313133dc05',
        user_tag: '中国全景第一人',
        user_desc: '1998年开始用Kodak数码相机拍摄VR全景，行业内被称为中国三维全景第一人，2011年被国际VR全景协会授予“当代全景摄影大师”称号',
        show_mobile: '',
        authorIconUrl: 'https://himg.bdimg.com/sys/portrait/item/public.1.d18fd6f0.kGTMZPHvXUZ-Mfv4SFdXsQ',
        jumpUrl: 'baidumap://map/cost_share?transparentWeb=0&navigationStatus=2&popRoot=no&hiddenBackBtn=0&needLocation=no&hiddenTitle=1&url=https%3A%2F%2Fscenes.map.baidu.com%2Fstatic%2Fh5-project%2Fpano-feed%2Fpano-feed.html%3FisTransparent%3D1%26uid%3D08de31313133323337313133dc05%26fr%3D%23%2Fhomepage',
        tagUrl: '',
        share_text: '',
        share_link: '',
        publicity_icon: '',
        publicity_title: '',
        publicity_subtitle: '',
        photo_name: '',
        v_icon: 'https://cjh-amis.cdn.bcebos.com/2023-2/1676455401227/v-red.png',
        like_num: 1000,
        user_type: 6
    }
};